import { AuthStore } from '../auth/auth';
import { AuthClient } from '../auth/auth-client';

export type Environment = {
  appNameSpace: string;
  authUrl: string;
  restApi: string;
  production?: boolean;
  sentryDSN?: string;
  xstateDebug?: boolean;
  patientAppUrl?: string;
  stripePublishableKey?: string;
};

export class RootStore {
  authClient: AuthClient;
  authStore: AuthStore;
  environment: Environment;

  constructor(environment: Environment) {
    this.environment = environment;
    this.authClient = new AuthClient(environment);
    this.authStore = new AuthStore(this.authClient);
  }

  static createRootStore = (environment: Environment) => new RootStore(environment);
}
